/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { RolesResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Roles<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetRoles
   * @request GET:/roles
   * @secure
   */
  getRoles = (params: RequestParams = {}) =>
    this.request<RolesResponse, any>({
      path: `/roles`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsRoles
   * @request OPTIONS:/roles
   */
  optionsRoles = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/roles`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsRoles2
   * @request OPTIONS:/roles/{id}
   * @originalName optionsRoles
   * @duplicate
   */
  optionsRoles2 = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/roles/${id}`,
      method: 'OPTIONS',
      ...params,
    });
}
